const styles = {
  searchFieldWrapper: {
    px: 2,
    width: '100%',
    mb: 2,
  },
  isHidden: {
    opacity: 0,
    pointerEvents: 'none',
  },
}

export default styles
